<template>
    <div class="left_panel design_studio_panel name_numbers_panel">
        <div class="hight_auto">
            <form
                method="post"
                @submit.prevent="submitNameNumber"
                data-vv-scope="addroleform"
            >
                <div id="div1" v-if="step === 1">
                    <div
                        class="tools_headding catgory_headding w-100 name_number_heading"
                    >
                        <h4 class="heading5">Add Name & Number</h4>
                        <a
                            href="#"
                            @click="$emit('closeMenu', 'nn-tab')"
                            class="ml-auto mr_10"
                            title="Close"
                        >
                            <img
                                src="/maincss/images/tool_close.svg"
                                alt="img"
                            />
                        </a>
                    </div>
                    <div class="add_name_no_form_start">
                        <div class="col-md-6 add_name">
                            <div class="form-group">
                                <input
                                    id="addNames"
                                    type="checkbox"
                                    required="required"
                                    class=""
                                    @change="onAddChange($event, 'name')"
                                    v-model="addName"
                                />
                                <label>Add Name</label>
                                <button @click="removeSelections"></button>
                                <span class="icon_text">
                                    <img src="/maincss/images/name.png" />
                                </span>
                            </div>
                            <div class="form_group_label">
                                <div class="label-col-2">
                                    <label>Font</label>
                                </div>
                                <div class="select-col-10">
                                    <select
                                        class="span2 form-control bg-transparent"
                                        v-model="
                                            colorSizesForName.nameFontFamily
                                        "
                                        @change="
                                            onFontFamilyChange($event, 'name')
                                        "
                                    >
                                        <option>Verdana</option>
                                        <option>Arial</option>
                                        <option>Georgia</option>
                                    </select>
                                </div>
                            </div>
                            <div class="form_group_label">
                                <div class="label-col-2">
                                    <label>Size</label>
                                </div>
                                <div class="select-col-10">
                                    <select
                                        id="nameFontSizes"
                                        class="span2 form-control bg-transparent"
                                        v-model="colorSizesForName.nameFontSize"
                                        @change="
                                            onFontSizeChange($event, 'name')
                                        "
                                    >
                                        <option value="21">1.5"</option>
                                        <option value="28">2"</option>
                                        <option value="42">3"</option>
                                    </select>
                                </div>
                            </div>
                            <div class="form_group_label add_name_mb">
                                <div class="label-col-2">
                                    <label>Color</label>
                                </div>
                                <div class="select-col-10 color_drop">
                                    <v-select
                                        width="100%"
                                        placeholder="Select-colors"
                                        label="name"
                                        class="span2 form-control bg-transparent"
                                        :options="vinyl_color_list"
                                        v-model="selected_name_color"
                                        :get-option-label="
                                            (option) => option.name
                                        "
                                        @input="
                                            onFontColorChange($event, 'name')
                                        "
                                    >
                                        <template
                                            #option="{ hex, name, swatches }"
                                        >
                                            <span v-if="hex">
                                                <cite
                                                    class="imprint_color_box"
                                                    v-bind:style="
                                                        'background:' + hex
                                                    "
                                                ></cite>
                                                {{ name }}
                                            </span>
                                            <span v-else>
                                                <img
                                                    class="imprint_color_box"
                                                    :src="swatches"
                                                    alt=""
                                                />
                                                {{ name }}
                                            </span>
                                        </template>
                                    </v-select>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 add_no">
                            <div class="form-group">
                                <input
                                    id="addNumbers"
                                    type="checkbox"
                                    required="required"
                                    class=""
                                    :checked="addNumber"
                                    @change="onAddChange($event, 'number')"
                                />
                                <label>Add Number</label
                                ><span class="icon_text"
                                    ><img src="/maincss/images/no.png"
                                /></span>
                            </div>
                            <div class="form_group_label">
                                <div class="label-col-2">
                                    <label>Font</label>
                                </div>
                                <div class="select-col-10">
                                    <select
                                        class="span2 form-control bg-transparent"
                                        v-model="
                                            colorSizesForNumber.numberFontFamily
                                        "
                                        @change="
                                            onFontFamilyChange($event, 'number')
                                        "
                                    >
                                        <option>Verdana</option>
                                        <option>Arial</option>
                                        <option>Georgia</option>
                                    </select>
                                </div>
                            </div>
                            <div class="form_group_label">
                                <div class="label-col-2">
                                    <label>Size</label>
                                </div>
                                <div class="select-col-10">
                                    <select
                                        class="span2 form-control bg-transparent"
                                        v-model="
                                            colorSizesForNumber.numberFontSize
                                        "
                                        @change="
                                            onFontSizeChange($event, 'number')
                                        "
                                    >
                                        <option
                                            v-for="(
                                                number_size, index
                                            ) in number_sizes_list"
                                            :key="index"
                                            :value="number_size.pixel_val"
                                        >
                                            {{ number_size.size_number }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="form_group_label add_name_mb">
                                <div class="label-col-2">
                                    <label>Color</label>
                                </div>
                                <div class="select-col-10 color_drop">
                                    <v-select
                                        width="100%"
                                        placeholder="Select-colors"
                                        label="name"
                                        class="span2 form-control bg-transparent"
                                        :options="vinyl_color_list"
                                        :get-option-label="
                                            (option) => option.name
                                        "
                                        v-model="selected_number_color"
                                        @input="
                                            onFontColorChange($event, 'number')
                                        "
                                    >
                                        <template
                                            #option="{ hex, name, swatches }"
                                        >
                                            <span v-if="hex">
                                                <cite
                                                    class="imprint_color_box"
                                                    v-bind:style="
                                                        'background:' + hex
                                                    "
                                                ></cite>
                                                {{ name }}
                                            </span>
                                            <span v-else>
                                                <img
                                                    class="imprint_color_box"
                                                    :src="swatches"
                                                    alt=""
                                                />
                                                {{ name }}
                                            </span>
                                        </template>
                                    </v-select>
                                </div>
                            </div>
                        </div>
                        <div class="bottom_btn_next add_num_btn_box">
                            <router-link
                                :to="{ name: 'team_uniform' }"
                                class="btn btn_orange bg_primary_orange text_white team_uniform_btn"
                            >
                                Team Uniform
                            </router-link>
                            <a
                                href="#"
                                @click.prevent="next()"
                                :class="
                                    'btn_next' +
                                    (isDisabled == true
                                        ? ' disable_next_btn '
                                        : '')
                                "
                                id="next"
                                >Next</a
                            >
                            <p>Step 2: Enter Names/Numbers</p>
                        </div>
                        <div
                            class="bottom_align_left_txt add_num_full_list_box"
                        >
                            <p>Full list required for accurate pricing</p>
                            <p class="mb_0">
                                Names: {{ icPriceFormat(name_fees) }} each item
                                | Numbers: {{ icPriceFormat(number_fees) }} each
                                item
                            </p>
                            <ul>
                                <li>
                                    - ‘YOUR NAME’ and ‘00’ are sample
                                    placeholders.
                                </li>
                                <li>
                                    - Our artists will expertly place each
                                    name/number from your list.
                                </li>
                                <li>
                                    - Names/numbers may be screen printed or
                                    vinyl.
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div id="div2" v-if="step === 2" class="next_tab">
                    <div
                        class="tools_headding catgory_headding w-100 add_name_num_inner_box"
                    >
                        <h4 @click.prevent="prev()" class="heading5 color_blue">
                            <span>
                                <img src="/maincss/images/back.png" />
                                Add Name & Number
                            </span>
                        </h4>
                        <a
                            href="#"
                            @click="$emit('closeMenu', 'nn-tab')"
                            class="ml-auto mr_10"
                            title="Close"
                            ><img
                                src="/maincss/images/tool_close.svg"
                                alt="img"
                        /></a>
                    </div>
                    <div class="enter_your_p_box">
                        <p>
                            Enter your full list and sizes for accurate pricing.
                        </p>
                    </div>
                    <div class="add_name_no_form_start inner_add_name_num_box">
                        <div
                            class="col-md-12 next_add_name new_name_and_number_box"
                        >
                            <div class="form_group_label next-col-3 s_no_wdth">
                                <div class="label-col-12">
                                    <label>S.No</label>
                                </div>
                            </div>
                            <div
                                v-show="nameChecked"
                                class="form_group_label next-col-3 name_wdth"
                            >
                                <div class="label-col-12">
                                    <label>Name</label>
                                </div>
                            </div>
                            <div
                                v-show="numberChecked"
                                class="form_group_label next-col-3 number_wdth"
                            >
                                <div class="label-col-12">
                                    <label>Number</label>
                                </div>
                            </div>
                            <div class="form_group_label next-col-3 size_wdth">
                                <div class="label-col-12">
                                    <label>Size</label>
                                </div>
                            </div>
                        </div>

                        <div class="name_and_number_scroll_box">
                            <div
                                v-for="(input, index) in addInputName"
                                v-bind:key="index"
                            >
                                <div class="col-md-12 next_add_name mb_20">
                                    <div
                                        class="form_group_label next-col-3 s_no_wdth"
                                    >
                                        <div class="select-col-12">
                                            <span class="name_and_num_serial_no"
                                                >{{ index + 1 }}.</span
                                            >
                                        </div>
                                    </div>
                                    <div
                                        v-show="nameChecked"
                                        class="form_group_label next-col-3 name_wdth"
                                    >
                                        <div class="select-col-12">
                                            <input
                                                type="text"
                                                oninput="this.value = this.value.toUpperCase()"
                                                @blur="onBlurChange"
                                                @input="
                                                    onInputChange(
                                                        $event,
                                                        'name'
                                                    )
                                                "
                                                v-model="input.name"
                                                maxlength="15"
                                                placeholder="Enter Name"
                                                class="span2 form-control bg-transparent"
                                            />
                                        </div>
                                    </div>
                                    <div
                                        v-show="numberChecked"
                                        class="form_group_label next-col-3 number_wdth"
                                    >
                                        <div class="select-col-12">
                                            <input
                                                type="number"
                                                onKeyPress="if(this.value.length == 2 || (event.key === 'ArrowUp' && this.value.length >= 2) || (event.key === 'ArrowDown' && this.value.length >= 2)) return false;"
                                                oninput="this.value = this.value.slice(0, 2)"
                                                min="00"
                                                max="99"
                                                step="1"
                                                @blur="onBlurChange"
                                                @input="
                                                    onInputChange(
                                                        $event,
                                                        'number'
                                                    )
                                                "
                                                v-model="input.number"
                                                maxlength="2"
                                                placeholder="##"
                                                class="span2 form-control bg-transparent"
                                            />
                                        </div>
                                    </div>
                                    <div
                                        class="form_group_label next-col-3 size_wdth"
                                    >
                                        <div class="select-col-12">
                                            <input
                                                type="text"
                                                v-model="input.size"
                                                placeholder="Size"
                                                class="span2 form-control bg-transparent"
                                                readonly
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            class="bottom_btn_next next_done inner_add_name_back_done_btn"
                        >
                            <div class="add_more"></div>
                            <div class="done d-flex" v-if="!buildId">
                                <a
                                    @click.prevent="prev()"
                                    class="btn_next"
                                    id="next"
                                    >Back</a
                                >
                                <a
                                    @click="$emit('closeMenu', 'nn-tab')"
                                    class="btn_next"
                                    id="next"
                                    >Done</a
                                >
                            </div>
                        </div>
                        <div class="bottom_align_left_txt helpful_hints_box">
                            <p class="hints">Helpful Links</p>
                            <ul>
                                <li>
                                    <router-link
                                        :to="{
                                            name: 'product_list',
                                            params: {
                                                product_type: 'apparel',
                                                category_id: product_category_id
                                            }
                                        }"
                                    >
                                        Click here to design more products
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </form>
            <div></div>
        </div>
    </div>
</template>

<script>
import { fabric } from "fabric";
import ApiService from "@/common/api.service";
var NameAndNumber = {
    name: "NameAndNumber",
    data: () => {
        return {
            step: 1,
            addName: false,
            addNumber: false,
            name: "",
            number: "",
            colorSizesForName: {
                nameFontFamily: "Verdana",
                nameFontColor: "Black",
                nameFontSize: 30,
                color_id: null,
                decor_upcharge: 0
            },
            colorSizesForNumber: {
                numberFontFamily: "Verdana",
                numberFontColor: "Black",
                numberFontSize: 60,
                color_id: null,
                decor_upcharge: 0
            },
            productSizeList: [],
            totalQty: 0,
            sizeList: [],
            addInputName: [],
            test: false,
            nameChecked: false,
            numberChecked: false,
            active_flip: "front", //active T-shirt side
            initialNameAndNumberData: null,
            vinyl_color_list: [],
            number_sizes_list: [
                {
                    pixel_val: 96,
                    size_number: 6
                },
                {
                    pixel_val: 128,
                    size_number: 8
                }
            ],
            name_fees: 0,
            number_fees: 0,
            selected_name_color: "",
            selected_number_color: "",
            product_category_id: ""
        };
    },
    props: [
        "canvasActiveObject",
        "selectedCheckbox",
        "frontCanvasTop",
        "frontCanvasLeft",
        "designBox",
        "adminOptions",
        "activeColorIndex",
        "activeGenderKey",
        "genderGroupsItems",
        "buildId"
    ],

    mounted() {
        this.getProductSize();
        this.showDefaultInputSize();
        this.getVinylColor();
        setTimeout(async () => {
            this.setGenderSizesInName();
            this.colorSizesForNumber.numberFontSize = "96";
        }, 1000);
        if (this.adminOptions) {
            let name_fee_obj = this.adminOptions.find(
                (option) => option.option_key == "name_fees"
            );
            let number_fee_obj = this.adminOptions.find(
                (option) => option.option_key == "number_fees"
            );
            if (name_fee_obj) {
                this.name_fees = parseFloat(name_fee_obj.option_value || 0);
            }
            if (number_fee_obj) {
                this.number_fees = parseFloat(number_fee_obj.option_value || 0);
            }
        }
    },
    computed: {
        isDisabled: function () {
            this.active_flip = localStorage.getItem("active_flip");
            return !this.nameChecked && !this.numberChecked;
        },
        // Count actual names and numbers that have been added (non-empty)
        actualNameCount: function () {
            if (!this.addInputName || !Array.isArray(this.addInputName)) {
                return 0;
            }
            return this.addInputName.filter(
                (item) => item.name && item.name.trim() !== ""
            ).length;
        },
        actualNumberCount: function () {
            if (!this.addInputName || !Array.isArray(this.addInputName)) {
                return 0;
            }
            return this.addInputName.filter(
                (item) => item.number && item.number.toString().trim() !== ""
            ).length;
        },
        // Total count of names and numbers added
        totalNameNumberCount: function () {
            return this.actualNameCount + this.actualNumberCount;
        }
    },
    methods: {
        removeSelections() {
            this.addName = this.selectedCheckbox;
            this.addNumber = this.selectedCheckbox;
            this.nameChecked = this.selectedCheckbox;
            this.numberChecked = this.selectedCheckbox;
            this.step = 1;
        },
        disableName() {
            setTimeout(async () => {
                let inputElement = document.getElementById("addNames");
                if (inputElement != null && inputElement != undefined) {
                    inputElement.disabled = true;
                }
            }, 300);

            this.number_sizes_list = [
                {
                    pixel_val: 40,
                    size_number: 2
                },
                {
                    pixel_val: 56,
                    size_number: 3
                },
                {
                    pixel_val: 64,
                    size_number: 4
                },
                {
                    pixel_val: 96,
                    size_number: 6
                }
            ];
        },
        enableName() {
            setTimeout(async () => {
                let inputElement = document.getElementById("addNames");
                if (inputElement != null && inputElement != undefined) {
                    inputElement.disabled = false;
                }
            }, 300);

            this.number_sizes_list = [
                {
                    pixel_val: 96,
                    size_number: 6
                },
                {
                    pixel_val: 128,
                    size_number: 8
                }
            ];
            this.colorSizesForNumber.numberFontSize = "96";
        },
        setGenderSizesInName() {
            let _this = this;
            let active_gender = localStorage.getItem("active_gender");
            /* eslint-disable */
            if (active_gender.includes("Adult")) {
                _this.colorSizesForName.nameFontSize = "42";
                $("#nameFontSizes option[value='21']").prop("disabled", true);
                $("#nameFontSizes option[value='28']").prop("disabled", true);
            } else if (active_gender.includes("Youth")) {
                _this.colorSizesForName.nameFontSize = "28";
                $("#nameFontSizes option[value='42']").prop("disabled", true);
            } else {
                _this.colorSizesForName.nameFontSize = "21";
                $("#nameFontSizes option[value='21']").prop("disabled", false);
                $("#nameFontSizes option[value='28']").prop("disabled", false);
                $("#nameFontSizes option[value='42']").prop("disabled", false);
            }
            /* eslint-enable */
        },
        getVinylColor() {
            //get only vinyl color with available hex color code
            var _this = this;
            new Promise(() => {
                ApiService.get("/get-vinyl-colors")
                    .then(({ data }) => {
                        _this.vinyl_color_list = data.color;
                        if (_this.vinyl_color_list.length > 0) {
                            _this.selected_name_color = data.color[0];
                            _this.selected_number_color = data.color[0];
                            _this.colorSizesForNumber.numberFontColor =
                                data.color[0].hex;
                            _this.colorSizesForNumber.color_id =
                                data.color[0].id;
                            _this.colorSizesForName.nameFontColor =
                                data.color[0].hex;
                            _this.colorSizesForName.color_id = data.color[0].id;
                        }
                    })
                    .catch(({ response }) => {
                        console.log(response.status.errors);
                    });
            });
        },
        clearNameAndNumber() {
            // this.$validator.reset();
            // this.$refs.formsNameAndNumber.reset();
            this.addInputName = JSON.parse(
                JSON.stringify(this.initialNameAndNumberData)
            );
        },
        loadNameAndNumber(color, panelStep = 1) {
            const active_flip = localStorage.getItem("active_flip");
            if (["front", "back"].includes(active_flip)) {
                this.getProductSize();
                this.addInputName = color.name_and_number_json;
                if (active_flip == "back") {
                    this.addName = color.selected_name_number[active_flip].name;
                }
                this.addNumber = color.selected_name_number[active_flip].number;
                if (active_flip == "back") {
                    this.nameChecked =
                        color.selected_name_number[active_flip].name;
                }
                this.numberChecked =
                    color.selected_name_number[active_flip].number;
                this.step = panelStep;

                if (color.font_color_sizes_name) {
                    this.colorSizesForName = color.font_color_sizes_name;
                }

                if (color.font_color_sizes_number) {
                    this.colorSizesForNumber = color.font_color_sizes_number;
                }
                this.$forceUpdate();
            }
        },
        nameAndNumberAddToCart() {
            this.test = false;
            let _this = this;
            let getAllSizesList = _this.groupArrayOfObjects(
                _this.addInputName,
                "size"
            );
            let count_sizes = {};
            console.log("check data for getAllSizesList", getAllSizesList);
            for (const [key, values] of Object.entries(getAllSizesList)) {
                count_sizes[key] = values.length;
            }
            let count_product_sizes = {};
            for (const [key, values] of Object.entries(_this.sizeList)) {
                count_product_sizes[values.sizeName] = parseInt(values.qty);
                console.log(key);
            }
            JSON.stringify(count_product_sizes), JSON.stringify(count_sizes);

            const new_count_product_sizes = Object.entries(count_product_sizes)
                .sort()
                .toString();
            const new_count_sizes = Object.entries(count_sizes)
                .sort()
                .toString();
            if (new_count_product_sizes != new_count_sizes) {
                this.test = true;
            }
            if (this.test) {
                _this.$toast.error("Entered sizes should be correct", {
                    position: "top-right",
                    queue: true
                });
                return 0;
            } else {
                return 1;
            }
        },
        submitNameNumber() {
            this.test = false;
            let _this = this;

            let getAllSizesList = _this.groupArrayOfObjects(
                _this.addInputName,
                "size"
            );
            let count_sizes = {};
            for (const [key, values] of Object.entries(getAllSizesList)) {
                count_sizes[key] = values.length;
            }
            let count_product_sizes = {};
            for (const [key, values] of Object.entries(_this.sizeList)) {
                count_product_sizes[values.sizeName] = parseInt(values.qty);
                console.log(key);
            }

            const new_count_product_sizes = Object.entries(count_product_sizes)
                .sort()
                .toString();
            const new_count_sizes = Object.entries(count_sizes)
                .sort()
                .toString();
            if (new_count_product_sizes != new_count_sizes) {
                this.test = true;
            }
            if (this.test) {
                _this.$toast.error("Entered sizes should be correct", {
                    position: "top-right",
                    queue: true
                });
            }
        },
        groupArrayOfObjects(list, key) {
            return list.reduce(function (rv, x) {
                (rv[x[key]] = rv[x[key]] || []).push(x);
                return rv;
            }, {});
        },
        findOcc(arr, key) {
            let arr2 = [];
            arr.forEach((x) => {
                // Checking if there is any object in arr2
                // which contains the key value
                if (
                    arr2.some((val) => {
                        return val[key] == x[key];
                    })
                ) {
                    // If yes! then increase the occurrence by 1
                    arr2.forEach((k) => {
                        if (k[key] === x[key]) {
                            k["occurrence"]++;
                        }
                    });
                } else {
                    // If not! Then create a new object initialize
                    // it with the present iteration key's value and
                    // set the occurrence to 1
                    let a = {};
                    a[key] = x[key];
                    a["occurrence"] = 1;
                    arr2.push(a);
                }
            });

            return arr2;
        },
        getProductSize() {
            let _this = this;
            let design_items = this.genderGroupsItems;
            if (design_items.length == 0) {
                return;
            }
            _this.product_category_id = design_items[0]["item"].category_id;
            const activeColorIndex = localStorage.getItem("colorIndex");
            if (design_items[0]["colors"]) {
                let selectedProdSize = design_items[0]["colors"][
                    activeColorIndex
                ].unique_sizes.filter((element) => element.quantity > 0);
                this.productSizeList = selectedProdSize;
                _this.totalQty = design_items[0].total_qty;
                for (let i = 0; i < this.productSizeList.length; i++) {
                    this.sizeList.push({
                        qty: this.productSizeList[i].quantity,
                        sizeName: this.productSizeList[i].Size.size,
                        totalQty: _this.totalQty
                    });
                }
            }
        },
        showDefaultInputSize() {
            let active_flip = localStorage.getItem("active_flip");
            const activeColorIndex = localStorage.getItem("colorIndex");
            const currentColor =
                this.genderGroupsItems[this.activeGenderKey].colors[
                    activeColorIndex
                ];
            this.addInputName = currentColor.name_and_number_json;
            if (["front", "back"].includes(active_flip)) {
                if (active_flip == "back") {
                    this.addName =
                        currentColor.selected_name_number[active_flip].name;
                }
            }
        },
        addMoreName() {
            this.addInputName.push({
                name: "",
                number: "",
                size: ""
            });
        },
        deleteMoreName(index) {
            this.addInputName.splice(index, 1);
        },
        closeMenu(menu_id) {
            alert();
            if (menu_id === "add-text") {
                this.onSelectedCleared();

                return;
            }

            var menu = document.querySelector("#" + menu_id);
            if (menu) {
                menu.classList.remove("active");
            }
            var menu_nav = document.querySelector("#" + menu_id + "-tab");
            if (menu_nav) {
                menu_nav.classList.remove("active");
            }
            this.active_class = "active";
            this.selected_category_heading = false;
            this.category_heading = true;
            this.edit_template = false;
            this.selected_template_category_show = false;
            this.selected_clipart_category_show = false;
        },
        prev() {
            setTimeout(async () => {
                this.setGenderSizesInName();
                let active_flip = localStorage.getItem("active_flip");
                if (active_flip == "front") {
                    this.disableName();
                }
            }, 1000);
            this.step--;
        },
        next() {
            this.step++;
        },
        onAddChange(e, type) {
            let active_flip = localStorage.getItem("active_flip");
            let gender_element = this.genderGroupsItems[this.activeGenderKey];
            if (type == "name") {
                this.addName = e.target.checked;
                if (active_flip == "back") {
                    gender_element.colors.forEach((color) => {
                        color.selected_name_number[active_flip].name =
                            e.target.checked;
                    });
                }
            } else {
                this.addNumber = e.target.checked;
                gender_element.colors.forEach((color) => {
                    color.selected_name_number[active_flip].number =
                        e.target.checked;
                });
            }

            if (e.target.checked) {
                this.$emit("undoAndRedo");
                if (type == "name") {
                    this.setGenderSizesInName();

                    if (active_flip != "back") {
                        this.$toast.error(
                            "Please select back canvas for adding name",
                            {
                                position: "top-right",
                                queue: true
                            }
                        );
                        return;
                    }
                    this.nameChecked = true;
                }
                if (type == "number") {
                    let active_flip = localStorage.getItem("active_flip");
                    if (active_flip == "front") {
                        this.colorSizesForNumber.numberFontSize = "40";
                    }
                    if (active_flip == "back") {
                        this.colorSizesForNumber.numberFontSize = "96";
                    }
                    if (active_flip == "left" || active_flip == "right") {
                        this.$toast.error(
                            "Please select back or front canvas for adding number",
                            {
                                position: "top-right",
                                queue: true
                            }
                        );
                        return;
                    }
                    this.numberChecked = true;
                }
                this.setComponent(type);
                this.$emit("updateNameNumberFees");
            } else {
                if (type == "name") {
                    this.nameChecked = false;
                    this.$emit("activeFrontType", false);
                }
                if (type == "number") {
                    this.numberChecked = false;
                }
                this.removeComponent(type);
            }
        },
        onBlurChange() {
            const activeColorIndex = localStorage.getItem("colorIndex");
            this.genderGroupsItems[this.activeGenderKey].colors[
                activeColorIndex
            ].name_and_number_json = this.addInputName;
            this.$emit("updateNameNumberFees");
        },
        onInputChange(e, type) {
            if (type == "name") {
                this.name = e.target.value;
            } else if (type == "number") {
                this.number = e.target.value;
            }
            this.setComponent(type);
        },
        onFontFamilyChange(e, type) {
            if (type == "name") {
                let active_flip = localStorage.getItem("active_flip");
                if (active_flip == "left" || active_flip == "right") {
                    this.$toast.error(
                        "Please select back or front canvas for adding number",
                        {
                            position: "top-right",
                            queue: true
                        }
                    );
                    return;
                }
                if (active_flip == "front") {
                    this.$toast.error(
                        "Please select back canvas for adding name",
                        {
                            position: "top-right",
                            queue: true
                        }
                    );
                    return;
                }
                this.colorSizesForName.nameFontFamily = e.target.value;
            } else if (type == "number") {
                let active_flip = localStorage.getItem("active_flip");
                if (active_flip == "left" || active_flip == "right") {
                    this.$toast.error(
                        "Please select back or front canvas for adding number",
                        {
                            position: "top-right",
                            queue: true
                        }
                    );
                    return;
                }
                this.colorSizesForNumber.numberFontFamily = e.target.value;
            }
            this.setComponent(type);
        },
        onFontSizeChange(e, type) {
            if (type == "name") {
                let active_flip = localStorage.getItem("active_flip");
                if (active_flip == "left" || active_flip == "right") {
                    this.$toast.error(
                        "Please select back or front canvas for adding number",
                        {
                            position: "top-right",
                            queue: true
                        }
                    );
                    return;
                }
                if (active_flip == "front") {
                    this.$toast.error(
                        "Please select back canvas for adding name",
                        {
                            position: "top-right",
                            queue: true
                        }
                    );
                    return;
                }
                this.colorSizesForName.nameFontSize = e.target.value;
            } else if (type == "number") {
                let active_flip = localStorage.getItem("active_flip");
                if (active_flip == "left" || active_flip == "right") {
                    this.$toast.error(
                        "Please select back or front canvas for adding number",
                        {
                            position: "top-right",
                            queue: true
                        }
                    );
                    return;
                }
                this.colorSizesForNumber.numberFontSize = e.target.value;
            }
            this.setComponent(type);
        },
        onFontColorChange(e, type) {
            if (type == "name") {
                let active_flip = localStorage.getItem("active_flip");
                if (active_flip == "left" || active_flip == "right") {
                    this.$toast.error(
                        "Please select back or front canvas for adding number",
                        {
                            position: "top-right",
                            queue: true
                        }
                    );
                    return;
                }
                if (active_flip == "front") {
                    let active_flip = localStorage.getItem("active_flip");
                    if (active_flip == "left" || active_flip == "right") {
                        this.$toast.error(
                            "Please select back or front canvas for adding number",
                            {
                                position: "top-right",
                                queue: true
                            }
                        );
                        return;
                    }
                    this.$toast.error(
                        "Please select back canvas for adding name",
                        {
                            position: "top-right",
                            queue: true
                        }
                    );
                    return;
                }
                //console.log(e);
                this.colorSizesForName.nameFontColor = e.hex;
                this.colorSizesForName.color_id = e.id;
            } else if (type == "number") {
                let active_flip = localStorage.getItem("active_flip");
                if (active_flip == "left" || active_flip == "right") {
                    this.$toast.error(
                        "Please select back or front canvas for adding number",
                        {
                            position: "top-right",
                            queue: true
                        }
                    );
                    return;
                }
                this.colorSizesForNumber.numberFontColor = e.hex;
                this.colorSizesForNumber.color_id = e.id;
            }
            this.$emit("updateNameNumberFees");
            this.setComponent(type);
        },
        setComponent(type) {
            /* eslint-disable */
            if (type == "name" && this.addName) {
                if (!this.canvasActiveObject) {
                    return;
                }
                const allObjects = this.canvasActiveObject.getObjects();
                var activeObject = allObjects.find(
                    (obj) => "name" === obj.toObject().objType
                );
                if (!activeObject) {
                    var textSample = new fabric.Text(this.name || "YOUR NAME", {
                        id: "name",
                        left: parseInt(this.frontCanvasLeft) + 8,
                        top: parseInt(this.frontCanvasTop) + 10,
                        fontFamily:
                            this.colorSizesForName.nameFontFamily || "Verdana",
                        fontWeight: "bold",
                        angle: 0,
                        fill: this.colorSizesForName.nameFontColor || "Black",
                        fontSize: this.colorSizesForName.nameFontSize || 30,
                        padding: 0,
                        selectable: false,
                        evented: false,
                        hasControls: false
                    });
                    textSample.toObject = (function (toObject) {
                        return function () {
                            return fabric.util.object.extend(
                                toObject.call(this),
                                {
                                    objType: "name",
                                    iextension: "svg",
                                    products_id:
                                        localStorage.getItem("product_id")
                                }
                            );
                        };
                    })(textSample.toObject);
                    this.canvasActiveObject.add(textSample);

                    textSample.centerH();
                    textSample.set("clipPath", this.designBox);
                }
                if (activeObject && activeObject.type === "text") {
                    activeObject.originX = "center";
                    activeObject.dirty = true;
                    activeObject.centerH();
                    activeObject.text = this.name || "YOUR NAME";
                    activeObject.fontFamily =
                        this.colorSizesForName.nameFontFamily || "Verdana";
                    activeObject.fontSize =
                        this.colorSizesForName.nameFontSize || 30;
                    activeObject.fill =
                        this.colorSizesForName.nameFontColor || "Black";
                    activeObject.set("clipPath", this.designBox);
                }
            } else if (type == "number" && this.addNumber) {
                if (!this.canvasActiveObject) {
                    return;
                }
                const allObjects = this.canvasActiveObject.getObjects();
                var activeObject = allObjects.find(
                    (obj) => "number" === obj.toObject().objType
                );
                if (!activeObject) {
                    var textSample = new fabric.Text(this.number || "00", {
                        id: "number",
                        left: parseInt(this.frontCanvasLeft) + 85,
                        top: parseInt(this.frontCanvasTop) + 55,
                        fontFamily:
                            this.colorSizesForNumber.numberFontFamily ||
                            "Verdana",
                        fontWeight: "bold",
                        angle: 0,
                        fill:
                            this.colorSizesForNumber.numberFontColor || "Black",
                        fontSize: this.colorSizesForNumber.numberFontSize || 60,
                        padding: 0,
                        selectable: false,
                        evented: false,
                        objType: "number",
                        originX: "center",
                        dirty: true,
                        hasControls: false
                    });
                    textSample.toObject = (function (toObject) {
                        return function () {
                            return fabric.util.object.extend(
                                toObject.call(this),
                                {
                                    objType: "number",
                                    products_id:
                                        localStorage.getItem("product_id")
                                }
                            );
                        };
                    })(textSample.toObject);
                    this.canvasActiveObject.add(textSample);
                    textSample.centerH();
                    textSample.set("clipPath", this.designBox);
                }
                if (activeObject && activeObject.type === "text") {
                    activeObject.originX = "center";
                    activeObject.dirty = true;
                    activeObject.centerH();
                    activeObject.text = this.number || "00";
                    activeObject.fontFamily =
                        this.colorSizesForNumber.numberFontFamily || "Verdana";
                    activeObject.fontSize =
                        this.colorSizesForNumber.numberFontSize || 60;
                    activeObject.fill =
                        this.colorSizesForNumber.numberFontColor || "Black";
                    activeObject.set("clipPath", this.designBox);
                }
            }
            /* eslint-enable */
            this.$emit("undoAndRedo");
            let _this = this;

            _this.active_flip = localStorage.getItem("active_flip");
            let canvasObject = JSON.stringify(activeObject);
            let canvasList1 = {};
            let previouscanvasList = {};
            previouscanvasList = JSON.parse(
                localStorage.getItem("new_canvas_elements")
            );
            if (previouscanvasList != null) {
                if (
                    previouscanvasList["front"] != null &&
                    _this.active_flip != "front"
                ) {
                    canvasList1["front"] = previouscanvasList["front"];
                }
                if (
                    previouscanvasList["back"] != null &&
                    _this.active_flip != "back"
                ) {
                    canvasList1["back"] = previouscanvasList["back"];
                }
            }
            canvasList1[_this.active_flip] = canvasObject;
            (canvasList1["products_id"] = localStorage.getItem("product_id")),
                localStorage.setItem(
                    "new_canvas_elements",
                    JSON.stringify(canvasList1)
                );
            this.canvasActiveObject.renderAll();
        },
        removeComponent(type) {
            if (!this.canvasActiveObject) {
                this.$emit("updateNameNumberFees");
                return;
            }
            const allObjects = this.canvasActiveObject.getObjects();
            /* eslint-disable */
            if (type == "name") {
                var activeObject = allObjects.find(
                    (obj) => "name" === obj.toObject().objType
                );
                if (activeObject) {
                    this.canvasActiveObject.remove(activeObject);
                    this.canvasActiveObject.renderAll();
                }
            } else if (type == "number") {
                var activeObject = allObjects.find(
                    (obj) => "number" === obj.toObject().objType
                );
                if (activeObject) {
                    this.canvasActiveObject.remove(activeObject);
                    this.canvasActiveObject.renderAll();
                }
            }
            /* eslint-enable */
            this.$emit("updateNameNumberFees");
        }
    }
};
export default NameAndNumber;
</script>
<style scoped>
.add_num_btn_box .disable_next_btn {
    pointer-events: none;
    opacity: 0.5;
}
</style>
